const ja = {
  title: "アカウントの種類を選択してください",
  subtitle: "コンプライアンス要件を遵守するため、実際の事業内容に基づき、適切な事業の種類を選択してください。",
  tip: "ヒント：異なる事業を同時に展開される場合は、複数の PingPong Checkout アカウントを申請してください。",
  tradeOfGoods: "貨物貿易",
  tradeOfService: "サービス貿易",
  confirm: "確認する",
  cancel: "ログアウト",
  pleaseSelectOne: "タイプを選択してください",
  whenConfirming: "{#@email@#} の取引タイプは「{#@type@#}」であり、確認後に変更することはできません。確認する？",
  tipWord: "確認",
  cancelWord: "キャンセル",
  activedWrods: "このアカウントは、「{#@type@#}」タイプの Web サイトのみを追加できます。",
  onSuccessTip: "操作は成功しました",
  accountType: "販売形態",
  businessType: "取引種別",
  onlineService: "オンラインサービス",
  offlineServices: "オムニチャネル決済"
};
export default ja;